<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.message {
  width: fit-content;
}

.markets-container {
  height: fit-content;
}

.collapse {
  transition: all 0s ease-in-out;
}

button.not-collapsed:focus {
  background-color: $primary !important;
  color: $light;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <b-form class="mx-auto main-margins mx-auto margin-top-content" @submit="submit">
    <b-row class="my-4">
      <b-col sm="3">
        <label for="name">Name</label>
      </b-col>
      <b-col sm="9">
        <b-form-input id="name" name="name" required v-model="creativeSet.name"></b-form-input>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col sm="3">
        <label for="file">Build file</label>
      </b-col>
      <b-col sm="7">
        <b-form-file
          name="file"
          :state="Boolean(creativeSet.buildFileDriveId)"
          ref="file"
          @change="handleFileUpload"
          :placeholder="
            creativeSet.buildFileDriveName ? creativeSet.buildFileDriveName : 'Choose a file or drop it here...'
          "
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </b-col>
      <b-col sm="2">
        <b-spinner class="ml-2" label="Loading..." v-if="loading"></b-spinner>
        <a v-if="creativeSet.buildFileDriveId && !loading" :href="creativeSet.buildFileUrl">Download</a>
      </b-col>
    </b-row>
    <b-row class="my-4 markets-container" v-if="!createMode">
      <b-col sm="3">
        <label for="Messages" v-if="!creativeSet.dataInDb">Markets & Messages</label>
        <label for="Messages" v-else>Markets</label>
      </b-col>
      <b-col sm="9" v-if="!creativeSet.dataInDb">
        <b-button
          v-for="creativeSetMarket in creativeSet.creativeSetMarkets"
          v-b-toggle="creativeSetMarket.market.id"
          :key="creativeSetMarket.market.id"
          class="m-0 p-1 mr-1 mt-1 market-btn bg-light border-primary"
          >{{ creativeSetMarket.market.name }}
        </b-button>

        <b-collapse
          v-for="creativeSetMarket in creativeSet.creativeSetMarkets"
          :id="creativeSetMarket.market.id"
          :key="creativeSetMarket.market.id + creativeSetMarket.market.name"
          accordion="my-accordion"
          class="mt-2 collapse"
        >
          <p class="d-inline-block mr-1 font-weight-bold text-primary">
            Messages in {{ creativeSetMarket.market.name }} :
          </p>
          <div
            v-for="message in creativeSetMarket.messages"
            :key="message.id"
            class="message m-0 p-1 mr-1 mt-1 bg-primary text-white rounded d-inline-flex"
          >
            {{ message.name }}
          </div>
        </b-collapse>
      </b-col>
      <b-col sm="9" v-else>
        <Multiselect
          :value="csm"
          @input="toggleCSM"
          :options="csmOptions"
          multiple
          :close-on-select="false"
          placeholder="Select markets"
          track-by="name"
          label="name"
          :disabled="!user.isAdmin"
        ></Multiselect>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col sm="3">
        <label for="state">State</label>
      </b-col>
      <b-col sm="9">
        <b-form-select id="state" v-model="creativeSet.state" :options="stateList"></b-form-select>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col sm="3">
        <label for="spreadsheetUrl">Gsheet / Database</label>
      </b-col>
      <b-col sm="9">
        <b-row class="ml-1">
          <b-form-checkbox
            size="lg"
            v-model="creativeSet.dataInDb"
            name="dataInDb"
            switch
            @change="switchDatasource"
            :disabled="!user.isAdmin"
          />
        </b-row>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col sm="3">
        <label for="spreadsheetUrl">Spreadsheet Url</label>
      </b-col>
      <b-col sm="9" class="d-flex gap-1">
        <b-form-input
          id="spreadsheetUrl"
          name="spreadsheetUrl"
          v-model="creativeSet.spreadsheetUrl"
          :readonly="!user.isAdmin"
          :state="UtilService.isValidUrl(creativeSet.spreadsheetUrl)"
        ></b-form-input>
        <b-btn variant="primary" v-if="creativeSet.dataInDb" @click="saveAssets">Refresh</b-btn>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col sm="3">
        <label for="spreadsheetUrl">Generate CSV</label>
      </b-col>
      <b-col sm="9" class="d-flex gap-1">
        <b-btn variant="primary" v-if="user.isAdmin" @click="generateCSV" :disabled="loadingCSV">Generate</b-btn>
      </b-col>
    </b-row>
    <b-row class="my-4 justify-content-between">
      <b-btn type="reset" class="border-white text-white" variant="projectManagement" :to="{ name: 'CreativeSets' }"
        >Return
      </b-btn>
      <b-btn type="submit" class="border-success text-white" variant="success" :disabled="loading">Save </b-btn>
    </b-row>
  </b-form>
</template>

<script>
import User from "@/domain/User";
import CreativeSet from "@/domain/CreativeSet";
import CreativeSetService from "@/services/CreativeSetService";
import MediaService from "@/services/MediaService";
import UserService from "@/services/UserService";
import ToastService from "@/services/ToastService";
import UtilService from "@/services/UtilService";
import Multiselect from "vue-multiselect";

export default {
  name: "CreativeSet",
  title: "Project Management - Disneyland CMP",

  data() {
    return {
      user: User.empty(),
      creativeSet: CreativeSet.empty(),
      csm: [],
      stateList: CreativeSet.stateList,
      createMode: this.$route.name === "CreativeSetCreate",
      loading: false,
      loadingCSV: false,
      lastSpreadsheetUrl: "",
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    UtilService() {
      return UtilService;
    },
    creativeSetId() {
      return this.$route.params.creativeSetId;
    },
    allCSM() {
      return this.creativeSet.creativeSetMarkets;
    },
    csmOptions() {
      const all = this.csm.length === this.creativeSet.creativeSetMarkets.length;
      return [
        { name: all ? "Remove all" : "Select all", value: null },
        ...this.creativeSet.creativeSetMarkets.map((csm) => ({ name: csm.market.name, value: csm })),
      ];
    },
  },
  methods: {
    async handleFileUpload(event) {
      const file = event.target.files[0];
      console.log("file", file);
      if (!file) return;
      const formData = new FormData();
      if (this.creativeSet.buildFileDriveId) {
        formData.append("id", this.creativeSet.buildFileDriveId);
      }
      formData.append("name", file.name);
      formData.append("file", file, file.name);
      this.loading = true;
      let resp = await MediaService.mediaUploadDrive(formData).finally(() => {
        this.loading = false;
      });

      this.creativeSet.buildFileDriveId = resp.buildFileDriveId;
      this.creativeSet.buildFileDriveName = resp.buildFileDriveName;
    },
    mergeCSM(creativeSetMarkets, allCreativeSetMarkets) {
      const existingMap = new Map(creativeSetMarkets.map((csm) => [csm.market.name, csm]));
      return allCreativeSetMarkets.map((csm) => {
        return existingMap.get(csm.market.name) ?? { ...csm, enabled: false };
      });
    },
    async submit(event) {
      event.preventDefault();
      const creativeSetToSend = { ...this.creativeSet };

      if (this.creativeSet.dataInDb) {
        creativeSetToSend.creativeSetMarkets = this.mergeCSM(
          this.csm.map((csm) => csm.value),
          this.allCSM
        );
      }

      await (this.createMode
        ? CreativeSetService.create(creativeSetToSend)
        : CreativeSetService.update(creativeSetToSend));

      this.$router.push({ name: "CreativeSets" });
    },
    async saveAssets() {
      if (!this.creativeSet.spreadsheetUrl) {
        ToastService.error("Error", "Spreadsheet url is required.");
        return;
      }
      const response = await CreativeSetService.checkSpreadsheetUrl(
        this.creativeSet.spreadsheetUrl,
        this.creativeSet.id
      );
      if (response.name) {
        const userConfirmed = window.confirm(
          `This spreadsheet URL is already used by the creative set "${response.name}". Do you want to continue?`
        );
        if (!userConfirmed) {
          return;
        }
      }
      ToastService.info("Loading", "Saving data into database...");
      try {
        if (!this.creativeSet.id) {
          this.creativeSet = await CreativeSetService.create(this.creativeSet);
          this.createMode = false;
        }
        await CreativeSetService.getAssetsIntoDb(this.creativeSet.spreadsheetUrl, this.creativeSet.id, this.csm);

        this.csm = this.creativeSet.creativeSetMarkets.map((csm) => {
          return { name: csm.market.name, value: csm };
        });

        ToastService.success("Success", "Data saved into database.");
      } catch (e) {
        ToastService.error("Error saving data into database", e.response.data.errors);
        if (e.response.data.warnings.length) {
          ToastService.warning("Warnings", e.response.data.warnings);
        }
      }
    },
    async generateCSV() {
      try {
        this.loadingCSV = true;
        ToastService.info("Loading", "Generating CSV...");
        const resp = await CreativeSetService.getCSV(this.creativeSet.id);
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "assets.csv");
        document.body.appendChild(link);
        link.click();
        link.remove();
        ToastService.success("Success", "CSV has been generated.");
      } catch (e) {
        ToastService.error("Error when trying to generate CSV", e);
      }
      this.loadingCSV = false;
    },
    async switchDatasource() {
      if (!this.creativeSet.spreadsheetUrl) {
        this.creativeSet.spreadsheetUrl = this.lastSpreadsheetUrl;
      } else {
        this.creativeSet.spreadsheetUrl = "";
      }
    },
    toggleCSM(values) {
      if (values.some((v) => v.name === "Select all")) {
        values = this.csmOptions.filter((option) => option.name !== "Select all");
      } else if (values.some((v) => v.name === "Remove all")) {
        values = [];
      }

      this.csm = values.map((v) => ({ name: v.name, value: { ...v.value, enabled: true } }));
    },
  },
  async mounted() {
    this.user = await UserService.getCurrentUser();
    if (this.createMode) {
      this.creativeSet = CreativeSet.empty();
    } else {
      this.creativeSet = await CreativeSetService.get(this.creativeSetId);
    }

    this.lastSpreadsheetUrl = this.creativeSet.spreadsheetUrl;

    if (!this.createMode) {
      this.creativeSet.creativeSetMarkets = this.creativeSet.creativeSetMarkets.sort((a, b) => {
        return a.market.name.localeCompare(b.market.name);
      });
      this.csm = this.creativeSet.creativeSetMarkets
        .filter((csm) => csm.enabled)
        .map((csm) => {
          return { name: csm.market.name, value: csm };
        });
    }
  },
};
</script>
